<div class="warehouse-edit">
  <div class="warehouse-edit__content">
    <div class="warehouse-edit__layout">
      <div class="warehouse-edit__header">
        <div class="warehouse-edit__heading">
          <h1 class="page-title">Edit Warehouse</h1>
          <p class="page-subtitle">Update warehouse information, address, and notes.</p>
        </div>
        <div class="warehouse-edit__actions">
          <app-button type="button" variant="secondary" (click)="goBack()">Back</app-button>
          <app-button type="button" [disabled]="!canSaveEntity" (click)="saveWarehouse()">
            {{ isSaving ? "Saving..." : "Save changes" }}
          </app-button>
        </div>
      </div>

      <app-card>
        <form [formGroup]="warehouseForm" class="warehouse-edit__form">
          <div class="warehouse-edit__form-field">
            <div class="warehouse-edit__form-label-row">
              <label for="name" class="warehouse-edit__form-label">Warehouse Name</label>
            </div>
            <input
              id="name"
              type="text"
              formControlName="name"
              class="warehouse-edit__form-input"
              [class.warehouse-edit__form-input--error]="warehouseForm.get('name')?.invalid && warehouseForm.get('name')?.touched" />
            @if (warehouseForm.get("name")?.invalid && warehouseForm.get("name")?.touched) {
            <div class="warehouse-edit__form-error">Warehouse name is required and must be at least 2 characters</div>
            }
          </div>

          <div class="warehouse-edit__form-field">
            <div class="warehouse-edit__form-label-row">
              <label for="note" class="warehouse-edit__form-label">Note</label>
            </div>
            <app-rich-text-editor formControlName="note" placeholder="Write warehouse notes..."></app-rich-text-editor>
          </div>
        </form>
      </app-card>

      <app-card class="warehouse-edit__address-card">
        <div class="warehouse-edit__section-header">
          <div>
            <h2 class="warehouse-edit__section-title">Address Information</h2>
            <p class="warehouse-edit__section-hint">Update the location hierarchy and address details.</p>
          </div>
        </div>

        <app-location-selector [value]="warehouse?.address" (addressChange)="onAddressChange($event)"></app-location-selector>
      </app-card>
    </div>
  </div>
</div>
